<div class="ya-bottomsheet-container ya-typography">
  <ya-bottomsheetclosebottom [bottomSheetRef]="bottomSheetRef"></ya-bottomsheetclosebottom>
    <h2>
      {{data.title}}
    </h2>
  <div class="ya-bottomsheet-content-center">
    <form #ratingForm="ngForm">
      <div class="rate-dialog-bar ya-header-2">
        <ng-container *ngIf="hasRating; then rateIfBlock else rateElseBlock"></ng-container>
        <ng-template #rateIfBlock>
          <bar-rating [(rate)]="ratingViewModel.rating" [max]="5" [readOnly]="true" [theme]="'fontawesome-o'">
          </bar-rating>
        </ng-template>
        <ng-template #rateElseBlock>
          <bar-rating name="rating" [(ngModel)]="ratingViewModel.rating" [max]="5" appRatingValueValidator
            [theme]="'fontawesome-o'"></bar-rating>
        </ng-template>
      </div>
      <div class="rate-comment-container">
        <textarea rows="9" name="message" [(ngModel)]="ratingViewModel.message" tabindex="-1"
          (keyup)="limitText($event.target.value)" [disabled]="hasRating"></textarea>
      </div>
      <div class="rate-comment-limitation">
        <span [class]="hasRating ? 'limitation-text-hidden' : 'limitation-text'">{{textAreaCounter+" "}}</span><span
          langkey="phRatingDialog_Characters_Available"></span>
          <div [ngClass]="(showValidationError && !ratingForm.valid && !hasRating) ? 'show-validation-error' : 'hide-validation-error'" class="rating-validation ya-caption">
            <span langkey="phRatingDialog_Validation_Message"></span>
          </div>
      </div>
      <div class="ya-dialog-action">
        <div class="ya-button-container">
          <ng-container
            *ngIf="(ratingForm.valid && !hasRating); then enabledbuttonTempalte else disabledbuttonTempalte">
          </ng-container>
          <ng-template #enabledbuttonTempalte>
            <button mat-flat-button (click)="saveRating()"><span langkey="phRatingDialog_SendRate"></span></button>
          </ng-template>
          <ng-template #disabledbuttonTempalte>
            <span (click)="showValidationMessage()">
              <button mat-flat-button disabled><span langkey="phRatingDialog_SendRate"></span></button>
            </span>
          </ng-template>
        </div>
      </div>
    </form>
  </div>
</div>